<template>
  <div class="mb-2 text-sm flex">
    <div class="flex-grow">
      <div>
        {{ $t("auction.product_category") }}: <span class="font-bold">{{ auction.category.code }}</span>
      </div>
      <div>
        {{ $t("auction.total_quantity") }}: <span class="font-bold">{{ auction.totalQuantity }} t</span>
      </div>
      <div>
        {{ $t('auction.min_quantity') }}: <span class="font-bold">{{ auction.totalQmg }} t</span>
      </div>
      <div>
        {{ $t("auction.lot_count") }}: <span class="font-bold">{{ auction.lotsCount }}</span>
      </div>
      <div v-for="attachment in auction.auctionAttachments" :key="'attachment-' + attachment.uuid" v-if="withAttachment">
        <a :href="config.AOL_API_URL + '/auction/' + auction.uuid + '/' + attachment.uuid + '?auth=' + accessToken"
          target="_blank">
          <PaperClipIcon class="h-4 w-4 inline-block" /> {{ attachment.description }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { PaperClipIcon } from '@heroicons/vue/24/solid';
import { inject } from "vue";
const { getAccessTokenSilently } = useAuth0();

const config = inject('config')
const accessToken = await getAccessTokenSilently()

const props = defineProps({
  auction: {
    type: Object,
    required: true
  },
  withAttachment: {
    type: Boolean,
    required: false,
    default: true
  }
})
</script>